import React from 'react'
import "../components/GC_CTA_1.css";

import { useAppContext } from './AppProvider';

const GC_CTA_1 = () => {

  const { openCalender, openCalendly } = useAppContext();


  return (
    <section className="cta-1">
      <div className="container text-center ">
        <div className="flex flex-col xl:flex-row gap-x-3 justify-center">
          <div className="hh1" data-aos-delay="0">Your Vision,</div>
          <div className="hh1 text-primary font-medium"  data-aos-delay="100">Our Execution.</div>
        </div>
        <div className="hh1  font-semibold"  data-aos-delay="200">Free Consultation.</div>

        <p className="xl:w-1/3 md:w-4/5 m-auto mt-6 "  data-aos-delay="220"><span className="opacity-70">Let’s explore your idea — we’ll analyze it and suggest </span>
          <span className="font-medium">what works best for you.</span></p>

        <div>
          <button onClick={openCalendly} className="mt-10 btn btn-native"  ><div>Book Your Slot<i></i></div></button>
        </div>
      </div>
    </section>
  )
}

export default GC_CTA_1
